import * as actionTypes from 'state/actions/actionTypes';

const INITIAL_STATE = {
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SAVE_MY_PROFILE.SUCCESS:
      return {
        state,
        ...action.payload,
      };
    default:
      return state;
  }
};
